import { ColumnSort } from "@tanstack/react-table";

export const sortWriter = (sorting: ColumnSort, sortMapping: Record<string, string>) => {
  return {
    ...{ sort: `${sorting.desc ? "-" : " "}${sortMapping[sorting.id] || sorting.id}` },
  };
};
